import { FC } from 'react';
import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { IComment } from '../../shared/interfaces/IComment';
import Helper from '../../shared/helpers/Helper';

interface Props {
  companyComment: IComment;
  sx?: SxProps<Theme>;
}

const Comment: FC<Props> = ({ companyComment, sx }) => {
  const theme = useTheme();

  const { username, userName, position, timestamp, date, name, comment, createdAt } =
    companyComment;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
        p: theme.spacing(2),
        borderRadius: `${theme.shape.borderRadius}px`,
        ...sx,
      }}
    >
      {[username, userName, name]
        .filter((f) => f)
        .map((user, index) => (
          <Typography
            key={index}
            variant="body1"
          >
            {user}
          </Typography>
        ))}
      {position && (
        <Typography
          variant="caption"
          sx={{ color: theme.palette.text.secondary }}
        >
          {position}
        </Typography>
      )}
      {[timestamp, createdAt, date]
        .filter((f) => f)
        .map((timestamp, index) => (
          <Typography
            key={index}
            variant="body2"
            sx={{ mb: theme.spacing(1), color: theme.palette.text.secondary }}
          >
            {Helper.getFormattedDate(timestamp, true)}
          </Typography>
        ))}
      {comment && (
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {comment}
        </Typography>
      )}
    </Box>
  );
};

export default Comment;
